<template>
  <section>
    <div class="form-content">
      <el-form-item label="所属仓库">
        <el-col :span="10">
          <el-select @change="forceUpdate" size="small" class="organization-select" v-model="form.houseId"
            placeholder="请选择材料所属仓库">
            <el-option v-for="item in houseList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>

      <el-form-item label="退库名称">
        <el-input placeholder="填入退库工程名/**维修退库/**新购退库" size="small" v-model="form.name"></el-input>
      </el-form-item>

      <el-form-item label="退库时间">
        <el-date-picker v-model="form.time" style="width:250px!important;" value-format="yyyy-MM-dd HH:mm:ss"
          size="mini" type="datetime" placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="材料明细">
        <section class="material-list">
          <div class="list-title">
            <div class="r">
              <el-button @click="AddMaterial()" type="primary" size="mini">添加材料</el-button>
            </div>
          </div>
          <div class="material-table">
            <el-table :data="form.materials" border>
              <el-table-column prop="material.material.number" label="材料编号">
              </el-table-column>
              <el-table-column prop="material.material.name" width="260" label="明细名称">
              </el-table-column>
              <el-table-column prop="material.material.unit.name" align="center" label="计量单位">
              </el-table-column>
              <el-table-column prop="" align="center" label="数量">
                <template slot-scope="scope">
                  {{ scope.row.amount && parseFloat(scope.row.amount).toFixed(2) }}
                </template>
              </el-table-column>

              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="点击变更信息" placement="bottom">
                    <i @click="MaterialChange(scope.row, scope.$index)"
                      class="iconfont icon-xiugai meeting-btn-icon  mbi-edit"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="点击删除" placement="bottom">
                    <i @click="MaterialDelete(scope.$index)"
                      class="iconfont icon-close meeting-btn-icon mbi-remove"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </section>
      </el-form-item>

      <el-form-item label="备注">
        <el-input type="textarea" placeholder="退库原因等情况说明" :autosize="{ minRows: 3, maxRows: 6}" size="small"
          v-model="form.remark"></el-input>
      </el-form-item>
    </div>

    <!-- 添加材料 -->
    <div class="pop-room" v-if="addStatus">
      <a href="javascript:;" @click="addStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="mform" label-width="120px" class="form">
            <el-form-item label="材料编号" v-if="mform.material">
              <el-input :disabled="true" size="small" v-model="mform.material.material.number"></el-input>
            </el-form-item>
            <el-form-item label="*明细名称">
              <el-select size="small" style="width:100%" filterable v-model="mform.materialId" @change="handleSelect"
                placeholder="支持搜索">
                <el-option v-for="item in materialList" :key="item.id"
                  :label="item.number+' - '+item.name+' ('+item.dl.name+') ('+item.spec+')'" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="*数量">
              <el-input size="small" type="number" v-model="mform.amount"></el-input>
            </el-form-item>

            <el-form-item label="计量单位" v-if="mform.material">
              <el-select :disabled="true" size="small" filterable v-model="mform.material.material.unit.id"
                placeholder="请选择计量单位">
                <el-option v-for="item in unitList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="">
              <el-button @click="AddBtnClick()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
    <div class="pop-room-bg" v-if="addStatus"></div>

  </section>

</template>
<script>
  export default {
    props: ['formByFather', 'userData', 'isBack'],
    data() {
      return {
        form: {},

        // 选择项目列表
        projectList: [],
        houseList: '',
        supplierList: '',
        unitList: '',
        customerList: '',

        addType: 0,
        editIndex: '',
        mform: {
          material: '',
          materialId: '',
          amount: '',
        },

        depId: '',
        addStatus: false,

      }
    },
    created() {
      this.depId = this.userData.secDepIds.split(",")[0] / 1
    },
    mounted() {
      this.form = this.formByFather

      this.getHouseList()
      this.getSupplierList()
      this.getUnitList()
      // this.getCustomerList()


      // this.getMaterialList()
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // // 获取客户名单
      // getCustomerList() {
      //   ajax.get('/storage/material/valid/customers', {
      //     houseId: this.form.houseId
      //   }, (res) => {
      //     this.customerList = res.vo.data
      //   })
      // },
      // // 获取项目列表
      // getProjectList(cb) {
      //   ajax.get('/contract/project/choose/list', {
      //     depId: this.depId
      //   }, (res) => {
      //     this.projectList = res.vo.array
      //     cb && cb()
      //   })
      // },

      // 查询材料
      handleSelect(materialId) {
        if (!this.form.houseId) {
          this.$message.error('请先选择退库仓库')
          return
        }
        // 查询材料资料
        ajax.post('/storage/material/queryBy/id', {
          id: materialId,
          houseId: this.form.houseId,
        }, (res) => {
          this.$set(this.mform, 'material', res.vo)
        })
      },
      // 编辑材料
      MaterialChange(row, index) {
        this.addType = 1
        this.editIndex = index
        this.mform = row
        this.addStatus = true
      },
      // 从列表里删除当前材料
      MaterialDelete(index) {
        this.form.materials.splice(index, 1)
      },
      // 显示添加材料弹窗
      AddMaterial() {
        if (!this.form.houseId) {
          this.$message.error('请先选择退库仓库')
          return
        }

        this.mform = {
          material: '',
          materialId: '',
          amount: '',
        }
        this.addType = 0
        this.addStatus = true
      },
      // 添加材料到列表
      AddBtnClick() {
        if (!this.mform.materialId || !this.mform.amount) {
          this.$message.error("请认真填写材料信息，带*为必填项")
          return
        }

        this.mform.unitName = this.getUnitName(this.mform.unitId)
        if (this.addType == 0) {
          this.form.materials.push(this.mform)
        } else {
          this.form.materials.splice(this.editIndex, 1, this.mform)
        }

        // 初始化
        this.mform = {
          material: '',
          materialId: '',
          amount: '',
        }
        this.addStatus = false
      },
      // 获得计量单位名称
      getUnitName(unitId) {
        for (var i = 0; i < this.unitList.length; i++) {
          let _item = this.unitList[i]
          if (unitId == _item.id) {
            return _item.name
          }
        }
      },
      // 获取材料基础资料列表
      getMaterialList() {
        ajax.get('/storage/material/orderby/stock/list', {
          // houseId: this.form.houseId
        }, (res) => {
          this.loading = false
          this.materialList = res.vo.array
        })
      },
      // 获取仓库列表
      getHouseList() {
        ajax.get('/storage/house/list', {
          'depId': this.depId,
          // level: '1'
        }, (res) => {
          this.houseList = res.vo.array
          if (this.houseList.length < 1) {
            this.$message.error("你所在的公司还没有建立仓库，无法进行材料退库")
          }
        })
      },
      // 获取供应商列表
      getSupplierList() {
        ajax.get('/supplier/list', {
          'type': 1
        }, (res) => {
          this.supplierList = res.vo.array
        })
      },
      // 获取计量单位列表
      getUnitList() {
        ajax.get('/storage/unit/list', '', (res) => {
          this.unitList = res.vo.array
        })
      },
      // 返回form
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      },
      'form.houseId'() {
        this.getMaterialList()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/materialBackForce.vue